module.exports = __webpack_public_path__ + "media/images/facebook_icon2-f63937bf9a24cf3f4f0626cd4f41045a.png";